module.exports = __webpack_public_path__ + "img/review.040d64c4.svg";